import { useMemo } from 'react';

import useSeedMetadata from './useSeedMetadata';

const useTradingSeason = (tradingSeasonCode = '') => {
  const {
    state,
    selectors: { selectTradingSeason },
  } = useSeedMetadata();

  return useMemo(
    () => selectTradingSeason(state, tradingSeasonCode),
    [state, tradingSeasonCode, selectTradingSeason],
  );
};

export default useTradingSeason;
